export default __webpack_public_path__ + "static/media/jinsoo_crop.2e023502.jpg";